/**
 * Combobox props for a Mantine dropdown rendered inside one of the console's MUI dialogs.
 *
 * <p>Mantine portals a dropdown to `<body>` — a sibling of the dialog, not a descendant — at its
 * own default z-index of ~300. The console's modals sit at 1300, so without this the dropdown
 * opens, positions itself correctly under the field, and paints *behind* the dialog: the options
 * are present in the DOM and nothing is on screen. The field then reads as a plain text input,
 * which is exactly how it gets reported.
 *
 * <p>Exported so the next modal takes the value rather than a fifth inline copy of it. Four
 * already exist (tower's CarrierReferenceSelect, the agency wizard, and two under ask-moo).
 */
export const DIALOG_DROPDOWN_Z_INDEX = 1401;

export const DIALOG_DROPDOWN_PROPS = {
  withinPortal: true,
  zIndex: DIALOG_DROPDOWN_Z_INDEX,
} as const;
